<template>
  <v-flex xs12 sm6 md6 lg4 xl3 px-3 mb-2 class="sortable on-white-background">
    <v-card class="bucket-lid rounded-3 elevation-2 cardBackground"></v-card>
    <v-card class="px-4 py-2 mb-2 rounded-3 elevation-2 cardBackground">
      <v-card-title class="pa-0 pb-2 pt-1">
        <v-flex xs12 pr-4 pt-1>
          <h4 class="text-truncate">
            <span
              class="primary-text body-1 opacity-54"
            >{{ (bucket.contents && bucket.contents.statistics) ? bucket.contents.statistics.total : " &nbsp;" }} {{ pluralizedCaseTypeName }}</span>
          </h4>
        </v-flex>
        <v-flex xs12>
          <h3 class="icon-bold-link primary--text text-truncate mt-1 mb-0 pb-1 pr-3">{{bucket.name}}</h3>
        </v-flex>
      </v-card-title>
      <v-card-actions class="card-vert-menu">
          <v-tooltip top color="secondary" v-if="mode==='add'">
          <v-btn
            flat
            icon
            dark

            @click="add()"
            slot="activator"
            class="ma-0 mr-0 pa-0"
            color="secondary"
            style="margin-top:calc(50% - 8px) !important; margin-left:-10px !important;"
          >
            <v-icon color="success">add_circle</v-icon>
          </v-btn>
          <span>Add to bucket group</span>
        </v-tooltip>
        <v-tooltip top color="secondary" v-else>
          <v-btn
            flat
            icon
            dark
            @click="remove()"
            slot="activator"
            class="ma-0 mr-0 pa-0"
            color="secondary"
            style="margin-top:calc(50% - 8px) !important; margin-left:-10px !important;"
          >
            <v-icon color="error">remove_circle</v-icon>
          </v-btn>
          <span>Remove from bucket group</span>
        </v-tooltip>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState } from "vuex"
import inflection from "inflection"

export default {
  name: "SortableBucketTile",
  props: {
    bucket: {
      type: Object,
      required: true
    },
    position: {
      type: Number,
      required: true
    },
    mode: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapState({
      bucketGroupId: state => state.cbroute.params.bucket_group_id
    }),
    pluralizedCaseTypeName() {
      const name =
        this.bucket && this.bucket.caseTypeName
          ? inflection.pluralize(this.bucket.caseTypeName)
          : ""
      return name
    }
  },
  methods: {
    remove() {
      this.$emit("remove-bucket", this.bucket.id)
    },
    add() {
      this.$emit("add-bucket", this.bucket.id)
    }
  }
}
</script>
